import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainChargeMoney(params) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/chargeMoney`,
    method: "post",
    params: params,
  });
}
